var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAccount(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "default",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "24px",
    height: "24px",
    viewBox: "-467 269 24 24",
    style: {
      enableBackground: "new -467 269 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-455,271c5.5,0,10,4.5,10,10s-4.5,10-10,10s-10-4.5-10-10S-460.5,271-455,271 M-455,269c-6.6,0-12,5.4-12,12 s5.4,12,12,12s12-5.4,12-12S-448.4,269-455,269L-455,269z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-451.2,282.9c-0.2-0.1-1-0.6-1.3-0.3c-0.4,0.4-1.5,1.3-2.5,1.3l0,0l0,0c-1,0-2.1-0.9-2.5-1.3 c-0.3-0.3-1.1,0.2-1.3,0.3c-0.6,0.4-0.7,0.5-1.2,1.1c-0.3,0.3-0.5,0.7-0.7,1c1.3,1.8,3.4,3,5.7,3c2.4,0,4.5-1.2,5.7-3 c-0.2-0.3-0.4-0.7-0.7-1C-450.4,283.5-450.6,283.3-451.2,282.9z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-451.8,277.4c0,2-1.6,4-3.2,4s-3.2-2.1-3.2-4s1.4-3.6,3.2-3.6S-451.8,275.4-451.8,277.4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccount);
export default __webpack_public_path__ + "static/media/account.29ecc803a5c35a053993def9af687a2e.svg";
export { ForwardRef as ReactComponent };